module.exports = __webpack_public_path__ + "static/media/service_talent.2e6cbbaf.png";